import { useParams } from "react-router-dom";
import { DirectoryDetailView } from "./DirectoryDetailView";

export function PersonDetailPage() {
  const { name } = useParams();
  const decoded = name ? decodeURIComponent(name) : "";

  if (!decoded) return null;

  return <DirectoryDetailView entityType="person" entityName={decoded} />;
}

(PersonDetailPage as unknown as { path: string }).path = "/people/:name";
